import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiUrl } from '../../../Network/ApiUrl';
import { post } from '../../../Network/ApiService';
import { RootState } from '../../index';
import { ToastMessage } from '../../../Components/Common/ToastMessage';

// Create the Thunk action

interface storeCheckoutSessionDataArgs {
    authToken: string;
    payload: any;
}

// Define the return type for the Thunk action
interface storeCheckoutSessionDataResponse {
    status: number;
    message: string;
}
export const storeCheckoutSessionData = createAsyncThunk<any, storeCheckoutSessionDataArgs, { state: RootState }>(
    'onboarding/storeCheckoutSessionData',
    async ({authToken,payload}) => {
        try {
            const ApiEndPoint = `${ApiUrl.stripe.create_checkout_session}`
            const response = await post(ApiEndPoint, authToken, payload);
            if (response.status === 200) {
                ToastMessage("success",response?.data.message);
                return response;
            } else {
                ToastMessage("error",response?.data.message);
                return { status: response.status, message: 'Error in saving Data' };
            }
        } catch (error) {
            ToastMessage("error",'Internal Server Error');
            return { status: 500, message: 'Internal Server Error' };
        }
    }
);
